import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31613f4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "scan-container"
}
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CameraBegging = _resolveComponent("CameraBegging")!
  const _component_fbx_qr_scanner = _resolveComponent("fbx-qr-scanner")!
  const _component_SvgXMark = _resolveComponent("SvgXMark")!
  const _component_VirtualRedTagInvalidQr = _resolveComponent("VirtualRedTagInvalidQr")!

  return (_ctx.cameraBeggingEnabled)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_CameraBegging, {
          onOnContinueClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCameraBegging = false))
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_fbx_qr_scanner, {
          paused: _ctx.isPaused,
          "instruction-text": "Position QR in frame",
          onScanned: _ctx.onScanned,
          onScannerReady: _ctx.onScannerReady,
          onScanError: _ctx.onScannerError
        }, null, 8, ["paused", "onScanned", "onScannerReady", "onScanError"]),
        _createElementVNode("button", {
          type: "button",
          class: "close-button",
          disabled: !_ctx.actionsEnabled,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navigateToWelcome && _ctx.navigateToWelcome(...args)))
        }, [
          _createVNode(_component_SvgXMark, { class: "close-button-icon" })
        ], 8, _hoisted_3),
        (_ctx.displayScanFailedOverlay)
          ? (_openBlock(), _createBlock(_component_VirtualRedTagInvalidQr, {
              key: 0,
              onManualEntry: _ctx.navigateToManualEntry,
              onBackToWelcome: _ctx.navigateToWelcome
            }, null, 8, ["onManualEntry", "onBackToWelcome"]))
          : _createCommentVNode("", true)
      ]))
}